module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/324.a7667fdd.png";